import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CreateCheck from './CreateCheck';
import CheckGridContainer from './CheckGrid';
import { Check } from './CreateCheck/CheckCreationModal';
import { SelectUser } from './common/SelectUser';
import { UserModel } from '../UsersTable';
import { Card, CardContent } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  header: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

const CheckScreen = () => {
  const classes = useStyles();
  const [addedCheck, setAddedCheck] = useState<Check | null>(null);
  const [selectedUser, setSelectedUser] = useState<UserModel | null>(null);

  const checkAdded = (newCheck: Check) => {
    if (!selectedUser)
      setAddedCheck(newCheck);
    else
      setSelectedUser(null);
  }

  const onUserSelected = (user: UserModel | null) => {
    setSelectedUser(user);
  }

  return (
    <div className={classes.container}>
      <Card>
        <CardContent className={classes.header}>
          <SelectUser default={selectedUser} onUserSelected={onUserSelected} displayHelper={false} label="Rechercher un utilisateur"/>
          <CreateCheck onCheckAdded={checkAdded}/>
        </CardContent>
      </Card>
      <CheckGridContainer checkAdded={addedCheck} selectedUser={selectedUser}/>
    </div>
  );
}

export default CheckScreen;